import { findPaperTotalMarksWithEvaluationId, isCandidateHaveReportResult } from 'gql/query'
import { reportDataGenerating } from './reportDataGenerating'
import { addCandidateReportResult, addNationalAverage, updateNationalAverage } from 'gql/mutations'
import { findNationalAverage, isCalculateNationalAverage } from './nationalAverage'
import dayjs from 'dayjs'

export const allCandidateResultGenerating = async (allResults: any) => {
  try {
    //first, filtering allresults because avoiding unexpected error
    const filteredResults = await allResults?.data.filter(
      (item: any) =>
        item.candidate_id !== null && item.candidate_id !== undefined && item?.application_id !== null && item?.application_id !== undefined
    )
    const evaluation_id = filteredResults[0].evaluation_id
    const Response: any = await findPaperTotalMarksWithEvaluationId(evaluation_id)
    const issue_date = Response?.evalationCreatedDate
    const paper_id = Response?.paperId
    const projectDetails = Response?.projectDetails || ''
    const test_track_id = Response?.test_track_id
    const getSlotDetails = Response?.testEventDetails?.slots?.find((slot: any) => slot?.test_track_id === test_track_id)
    const testEventSlotDate = getSlotDetails?.list_of_slots[0]?.date
    const tq = Response?.tq
    const testType = Response?.testType
    const paperTotalMarks = Response?.total_marks
    const product_id = Response?.product_id
    const product_name = Response?.product_name
    const test_track_name = Response?.test_track_name
    const slotData = JSON.parse(Response?.slotData)
    //reusing dayjs library, bz same library used for showing the test event details
    //Picking the test date from the test event if any case its null then taking it from the paper slot date
    const dateString = dayjs(testEventSlotDate || slotData.date).format('DD-MM-YYYY')
    //checking national average details if product is tq then with test_track only finding the national average
    const isNationalAverage: any = await isCalculateNationalAverage(test_track_id, tq ? undefined : product_id)
    const nationalAverageLabel = tq
      ? `${test_track_name} (test track)`
      : `${test_track_name} (test track) and ${product_name} (product)`

    //isCalculateNationalAverage returns nothing when its lookup fails, which is
    //not the same as the national average being absent - don't let that fall
    //through to the "please generate it" message below.
    if (!isNationalAverage || isNationalAverage?.lookupFailed) {
      return {
        status: false,
        message: `Could not read the national average for ${nationalAverageLabel}. Please try again, or contact the AMS admin if it keeps happening.`,
      }
    }

    let newTotalNationalAverage = null
    let newSectionWiseAverage = null
    if (isNationalAverage?.status === false) {
      //If national average is not in place so calculating
      // Use 365-day lookback (same as backend automation) and always include this evaluation
      const national_average_details = await findNationalAverage(test_track_id, tq ? undefined : product_id, {
        lookbackDays: 365,
        ensureEvaluationId: evaluation_id,
      })
      if (national_average_details?.status) {
        const sectional_national_average: any = []
        const sectional_details: any = {}
        const sectional_national_average_details = national_average_details?.totalAndSectionalAverages?.data
        await sectional_national_average_details.map((item: any) => {
          sectional_details.name = item?.name
          sectional_details.sectional_national_average = item?.sectional_average
          sectional_national_average.push({ ...sectional_details })
        })
        const national_average_data = {
          section_wise_average: sectional_national_average,
          product_id: tq ? null : product_id,
          test_track_id: test_track_id,
          product_name: tq ? null : product_name,
          test_track_name: test_track_name || null,
          total_national_average: national_average_details?.totalAndSectionalAverages?.national_average_of_paper,
          tq: tq,
          type: testType,
        }

        if (isNationalAverage?.canUpdate) {
          //if it need update
          const responseUpdateNationalAverage = await updateNationalAverage(isNationalAverage?.id, national_average_data)
          if (!responseUpdateNationalAverage?.status) {
            // Prefer existing stored average over blocking result generation
            const existing = isNationalAverage?.addNationalAverage?.national_average?.[0]
            if (existing?.section_wise_average != null && existing?.total_national_average != null) {
              newSectionWiseAverage = existing.section_wise_average
              newTotalNationalAverage = existing.total_national_average
            } else {
              return {
                status: false,
                message: `Re-calculate the national average for ${nationalAverageLabel} before generating the candidate results.`,
              }
            }
          } else {
            newSectionWiseAverage = national_average_data?.section_wise_average
            newTotalNationalAverage = national_average_data?.total_national_average
          }
        } else {
          //if it not then need to get added!
          const responseAddingNationalAverage = await addNationalAverage(national_average_data)
          if (!responseAddingNationalAverage?.status) {
            return {
              status: false,
              message: `Could not save the national average for ${nationalAverageLabel}. Please contact the AMS admin.`,
            }
          }
          newSectionWiseAverage = national_average_data?.section_wise_average
          newTotalNationalAverage = national_average_data?.total_national_average
        }
      } else if (isNationalAverage?.canUpdate && isNationalAverage?.addNationalAverage?.national_average?.[0]) {
        // Recalc failed but a (stale) national average already exists — use it so Generate Result is not blocked
        const existing = isNationalAverage.addNationalAverage.national_average[0]
        newSectionWiseAverage = existing.section_wise_average
        newTotalNationalAverage = existing.total_national_average
      } else {
        //findNationalAverage already knows exactly why it could not calculate
        return {
          status: false,
          message: `Could not generate the national average for ${nationalAverageLabel}. ${
            national_average_details?.message || 'Please contact the AMS admin.'
          }`,
        }
      }
    }

    // return {status: false,
    //   message: 'Work in progress'}
    const sectionWiseNationalAverage = isNationalAverage?.status
      ? isNationalAverage?.addNationalAverage?.national_average[0].section_wise_average
      : newSectionWiseAverage
    const total_national_average = isNationalAverage?.status
      ? isNationalAverage?.addNationalAverage?.national_average[0].total_national_average
      : newTotalNationalAverage
    const national_average_details = { total_national_average, sectionWiseNationalAverage }
    let addedCandidateResults = 0
    let alreadyExisting = 0
    const numberOfResults = filteredResults?.length
    // Allow 0 as a valid national average (falsy check used to block that case)
    if (sectionWiseNationalAverage == null || total_national_average == null) {
      return {
        status: false,
        message: `The national average for ${nationalAverageLabel} is incomplete - it has no section-wise or total average stored. Please re-calculate it from the National Average screen, or contact the AMS admin.`,
      }
    }
    await Promise.all(
      filteredResults.map(async (item: any) => {
        console.log(item, 'item is this')
        //checking candidate score is presented there or not ?
        let candidateReportResult: any = await isCandidateHaveReportResult(item?.application_id)
        console.log(candidateReportResult, 'result')
        let isCandidateResult = (await candidateReportResult) && candidateReportResult?.candidate_report_data.length !== 1 ? false : true

        //if not presented then only performing calculations and adding to DB
        if (!isCandidateResult) {
          const section_wise_report_theme_details: any[] = []
          const option_flag_details: any = {}
          let candidate_name = item?.candidate_name
          let candidate_id = item?.candidate_id
          let application_id = item?.application_id
          let school_id = item?.school_id ?? null
          let candidate_total_score = item?.total_score
          let skt_id = tq && item?.skt_id ? item.skt_id.replace('SKT_', '') : null
          const record = {
            evaluation_id: evaluation_id,
            candidate_id: candidate_id,
          }

          const response = await reportDataGenerating(record, paperTotalMarks)
          if (response?.findingTheTags && response?.findingTheTags.length > 0) {
            await response.findingTheTags.forEach((item: any) => {
              let reportThemeDetails: any = {}
              reportThemeDetails.section_name = item?.sectionName
              reportThemeDetails.report_theme_details = item?.details?.reportTheme
              section_wise_report_theme_details.push(reportThemeDetails)
            })
          }
          option_flag_details.percentageOfBlankResponse = response?.percentageOfBlankResponse
          option_flag_details.percentageOfCloseToCorrect = response?.percentageOfCloseToCorrect
          option_flag_details.percentageOfMostWrong = response?.percentageOfMostWrong

          let blooms_level_details = response?.bloomLevelDataToChart
          let section_level_percentages = response?.sectionLevelDetails?.sectionLevelPercentage
          let section_level_details: any = response?.sectionWiseReportData
          section_level_details.sectionWisePercentage = section_level_percentages
          section_level_details.total_marks = candidate_total_score
          section_level_details.test_track_name = response?.testTrackName
          section_level_details.test_date = dateString
          section_level_details.test_type = testType || 'tq'
          section_level_details.total_paper_score = paperTotalMarks
          section_level_details.All_Items_Greater_Than30 = response?.sectionLevelDetails?.allItemsGreaterThan30
          section_level_details.subjectname = response?.subjectName
          let digital_badge =
            testType !== 'tq'
              ? 'Not Available'
              : response?.sectionLevelDetails?.allItemsGreaterThan30 && (candidate_total_score / paperTotalMarks) * 100 >= 50
                ? 'Eligible'
                : 'Not Eligible'
          let test_date = testEventSlotDate
          let is_attended = response?.is_attended
          let is_eligible_for_result = response?.is_eligible_for_result

          const addCandidateResult = await addCandidateReportResult({
            application_id,
            candidate_name,
            section_level_details,
            section_wise_report_theme_details,
            blooms_level_details,
            option_flag_details,
            evaluation_id,
            national_average_details,
            skt_id,
            product_id,
            test_track_id,
            digital_badge,
            test_date,
            paper_id,
            test_type: testType || 'tq',
            issue_date,
            is_attended,
            is_eligible_for_result,
            school_id,
          })
          if (addCandidateResult?.status) {
            addedCandidateResults++
          }
        } else {
          alreadyExisting++
        }
      })
    )
    return {
      status: true,
      response: { addedCandidateResults, alreadyExisting, numberOfResults },
    }
  } catch (err) {
    console.log(err, 'error happend on all candidate result generation')
    return {
      status: false,
      message: 'Something went wrong, please contact AMS admin',
    }
  }
}
